import styled, { css } from 'styled-components'

export const StyledReportsTableContainer = styled.div`
    width: 100%;
    min-width: 768px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    font-size: 16px;
    color: ${({ theme }) => theme.greyishBrown};
    margin: 20px 0;
`
export const StyledReportsTableHeader = styled.div`
    padding: 10px 0;
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    color: ${({ theme }) => theme.grassyGreen};
    font-size: 15px;
    border-bottom: 1px solid ${({ theme }) => theme.veryLightPink};
    margin-bottom: 5px;
`

export const StyledReportsTableRow = styled.div.attrs(({ rowBackground }) => ({
        "data-background": rowBackground ? rowBackground : "rgba(48, 154, 2, 0.51)"
    }))`
    display: flex;
    padding: 15px 0;
    font-size: 15px;
    border-bottom: 1px solid ${({ theme }) => theme.veryLightPink};
    ${({ labels }) =>
        labels &&
        css`
            font-weight: ${({ theme }) => theme.fontWeight.bold};
    `}
`

export const StyledReportsTableCell = styled.div`
    flex: 1;
    padding: 0 10px;
    &:first-child {
        max-width: 65px;
    }
`

export const StyledNumber = styled.div`
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: ${({ backgroundColor }) => backgroundColor ? backgroundColor : "#24402C"};
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    color: ${({ theme }) => theme.whiteTwo};
    margin-right: 5px;
    cursor: pointer;
`

export const StyledData = styled.div`
    color: ${({ theme }) => theme.greyishBrown};
`

export const StyledTime = styled.div`
    color: ${({ theme }) => theme.brownGrey};
    letter-spacing: 0.44px;
`
